import { Well } from "react-bootstrap";
import styled from "styled-components";
import { Table } from "react-bootstrap";

export const GridWrapper = styled.div`
    height: 250px;

    .ag-header {
        background-color: #133666;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-header-cell {
        color: white;
    }

    .ag-cell {
        font-family: Roboto;
        text-align: center;
    }

    .ag-body-viewport {
        border: 1px solid #133666;
    }

    .ag-header-cell-label {
        justify-content: center;
    }

    .ag-icon {
        color: white;
    }
`;

export const FilterWrapper = styled(Well)`
    @media screen and (max-width: 1877px) {
        font-size: 12px;

        input.form-control {
            font-size: 12px;
        }

        input[name=email] {
            width: 180px !important;
        }

        input[name=birthDate] {
            width: 80px !important;
        }
    }
`;

export const TableWrapper = styled(Table)`
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }

    @media screen and (max-width: 1877px) {
        & > thead > tr > th,
        & > tbody > tr > td {
            font-size: 12px;
        }
    }
`;